import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

const HomeHelmet = props => {
  const url = `https://www.javascriptstuff.com${props.path}`;
  const name = `JavaScript Stuff`;
  const description = props.description;
  const metaImagePath = `https://www.javascriptstuff.com/meta-home.png`;

  return (
    <Helmet>
      <title>{name}</title>

      {/* General meta tags */}
      <meta name="title" content={name} />
      <meta name="description" content={description} />
      <meta itemProp="title" content={name} />
      <meta itemProp="description" content={description} />
      <meta itemProp="image" content={metaImagePath} />

      {/* Twitter card */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@ahfarmer" />
      <meta name="twitter:creator" content="@ahfarmer" />
      <meta name="twitter:title" content={name} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={metaImagePath} />

      {/* Open Graph */}
      <meta name="og:title" content={name} />
      <meta name="og:type" content="article" />
      <meta name="og:url" content={url} />
      <meta name="og:description" content={description} />
      <meta name="og:site_name" content="JavaScript Stuff" />
      <meta name="og:image" content={metaImagePath} />
    </Helmet>
  );
};
HomeHelmet.propTypes = {
  path: PropTypes.string,
  description: PropTypes.string
};
HomeHelmet.defaultProps = {
  path: "/",
  description:
    "Helping you find & learn modern JS tools w/ lists, guides, and articles."
};
export default HomeHelmet;



// WEBPACK FOOTER //
// ./src/components/home/HomeHelmet.js